import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/providers/authentication.service';
import { UserService } from 'src/app/providers/user.service';
import { environment } from '../../../environments/environment';
import { IUser } from 'src/app/interfaces/user';
import { Toast, ToastrService } from 'ngx-toastr';
import { ModalComponent } from '../../modals/modal.component';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: true,
    imports: [ModalComponent]
})
export class DashboardComponent implements OnInit {

  // @Input() tabs;
  // @Output() changeTabEvent: EventEmitter<number> = new EventEmitter<number>();

  menu = {
    none: 0,
    list : 1,
    campCreate: 2,
    campManage: 3
  };
  submenu = this.menu.none;

  client: IUser;
  clientMLP = false;
  clientADE = false;
  showLogoutConfirm = false;

  sitename = 'isms.pro'

  constructor(
    private router: Router,
    public authService: AuthenticationService,
    private userService: UserService,
    private toastr: ToastrService,
  ) {

    if (window.location.origin.includes('isisms.fr')) {
      this.sitename = "isisms.fr";
    }

  }

  ngOnInit() {
    console.log('init dashboard');
    this.userService.getCurrentClient();
    this.userService.selectedUser$.subscribe( user => {
      if (user) {

        this.client = user;
        this.clientMLP = (this.client.company === 'MLP');
        this.clientADE = (this.client.company === 'ADE');
      }
    });
  }

  openLink(link) {
    console.log('openLink', link);
    if (this.client) {
      this.router.navigate([link]);
    } else {
      this.toastr.info('Sélectionnez un client en premier !', '');
    }
  }

  openLinkNoCheck(link) {
    this.router.navigate([link]);
  }

  openMenu(choice) {
    console.log('openMenu', choice);
    if (this.client) {
      if (this.submenu === choice) {
        this.submenu = this.menu.none;
      } else {
        this.submenu = choice;
      }
    } else {
      this.toastr.info('Sélectionnez un client en premier !', '');
    }
  }

  closeMenu() {
    this.submenu = this.menu.none;
  }

  logout() {
    this.showLogoutConfirm = true;
  }

  logoutConfirm() {
    this.showLogoutConfirm = false;
    this.authService.logout();
    this.userService.clearSelectedUser();
  }

  openTutos() {
    const url = environment.apiUrl;
    window.open(
      url + '/show_pdf.php?id=0&docid=0',
      '',
      'toolbar=no, menubar=no,scrollbars=yes,resizable=yes,location=no,directories=no,status=no, width=1000, height=700');
  }

}
